import { FC, useEffect, useState } from 'react'
import { NotFoundDetail } from '../NotFoundDetail'
import { Container, Logo } from './styled'

export const Loader: FC = () => {
  const [flag, setFlag] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setFlag(true)
    }, 10000)
    return () => clearTimeout(timer)
  }, [])

  return <Container>{flag ? <NotFoundDetail /> : <Logo />}</Container>
}
